window.chartPlanungsvergleich = {
	data: {
		kontostand1: [],
		kontostand2: [],
		einnahmen1: [],
		einnahmen2: [],
		ausgaben1: [],
		ausgaben2: [],
		ueberliquiditaeten1: [],
		ueberliquiditaeten2: [],
		liquidierungen1: [],
		liquidierungen2: [],

		kapitalanlagen1: [],
		kapitalanlagen2: [],
		sonstigevermoegenswerte1: [],
		sonstigevermoegenswerte2: [],
		immobilien1: [],
		immobilien2: [],
		unternehmen1: [],
		unternehmen2: [],

		liquiditaet1: [],
		liquiditaet2: [],

		bruttovermoegen1: [],
		bruttovermoegen2: [],
		nettovermoegen1: [],
		nettovermoegen2: [],
		verbindlichkeiten1: [],
		verbindlichkeiten2: [],

		status: "differenziert",
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_planungsvergleich", {
			tooltip: {
				pointFormatter: function () {
					if (this.y != 0) {
						return `<span>${this.series.name}: ${Highcharts.numberFormat(this.y, 0)}&nbsp;€</span>`
					} else return false
				},
			},

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
					},
				},
			},

			yAxis: [
				{
					height: "45%",
					offset: 0,
				},
				{
					height: "45%",
					opposite: true,
					offset: 0,
				},
				{
					top: "30%",
					height: "0%",
					offset: 0,
					visible: false,
				},

				{
					top: "55%",
					height: "45%",
					offset: 0,
				},
				{
					top: "55%",
					height: "45%",
					opposite: true,
					offset: 0,
				},
				{
					top: "85%",
					height: "0%",
					offset: 0,
					visible: false,
				},
			],

			legend: {
				enabled: true,
			},

			plotOptions: {
				area: {
					stacking: "normal",
				},
			},

			series: this.seriesLiqui(),
		})
		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesNetto()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateYAxis(anzahl) {
		if (anzahl == 1) {
			this.chart.yAxis[0].update({ height: "45%", offset: 0 })
			this.chart.yAxis[1].update({ height: "45%", offset: 0, opposite: true })
			this.chart.yAxis[2].update({ height: "0%", visible: false })
			this.chart.yAxis[3].update({ height: "45%", top: "55%", offset: 0 })
			this.chart.yAxis[4].update({ height: "45%", top: "55%", offset: 0, opposite: true })
			this.chart.yAxis[5].update({ height: "0%", visible: false })
		} else {
			this.chart.yAxis[0].update({ height: "30%", offset: 0 })
			this.chart.yAxis[1].update({ height: "30%", offset: 0, opposite: true })
			this.chart.yAxis[2].update({ height: "15%", top: "30%", offset: 0, visible: true })
			this.chart.yAxis[3].update({ height: "30%", top: "55%", offset: 0 })
			this.chart.yAxis[4].update({ height: "30%", top: "55%", offset: 0, opposite: true })
			this.chart.yAxis[5].update({ height: "15%", top: "85%", offset: 0, visible: true })
		}
	},

	updateSeriesData(seriesData) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Kontostand",
				id: "kontostand1",
				legendName: "Kontostand",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 0,
				data: this.data.kontostand1,
			},
			{
				name: "Kontostand",
				id: "kontostand2",
				legendName: "Kontostand",
				yAxis: 3,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 0,
				linkedTo: "kontostand1",
				data: this.data.kontostand2,
			},
			{
				name: "Einnahmen",
				id: "einnahmen1",
				legendName: "Einnahmen",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				index: 2,
				legendIndex: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: this.data.status == "differenziert" ? true : false,
				data: this.data.einnahmen1,
			},
			{
				name: "Einnahmen",
				id: "einnahmen2",
				legendName: "Einnahmen",
				yAxis: 4,
				type: "column",
				color: farbeEinnahmen,
				index: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "einnahmen1",
				data: this.data.einnahmen2,
			},
			{
				name: "Ausgaben",
				id: "ausgaben1",
				legendName: "Ausgaben",
				yAxis: 1,
				type: "column",
				color: farbeAusgaben,
				index: 2,
				legendIndex: 3,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: this.data.status == "differenziert" ? true : false,
				data: this.data.ausgaben1,
			},
			{
				name: "Ausgaben",
				id: "ausgaben2",
				legendName: "Ausgaben",
				yAxis: 4,
				type: "column",
				color: farbeAusgaben,
				index: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "ausgaben1",
				data: this.data.ausgaben2,
			},
			{
				name: "Saldo",
				id: "saldo1",
				legendName: "Saldo",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				negativeColor: farbeAusgaben,
				index: 3,
				legendIndex: 2,
				zIndex: 2,
				stack: "ein_ausgaben",
				visible: this.data.status == "differenziert" ? false : true,
				showInLegend: this.data.status == "differenziert" ? false : true,
				data: this.data.saldo1,
			},
			{
				name: "Saldo",
				id: "saldo2",
				legendName: "Saldo",
				yAxis: 4,
				type: "column",
				color: farbeEinnahmen,
				negativeColor: farbeAusgaben,
				index: 3,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "saldo1",
				data: this.data.saldo2,
			},
			{
				name: "Automatische Liquidierung",
				id: "liquidierung1",
				legendName: "Cash-Pooling",
				yAxis: 1,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				legendIndex: 4,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "ueberliquiditaet1",
				data: this.data.liquidierungen1,
			},
			{
				name: "Automatische Liquidierung",
				id: "liquidierung2",
				legendName: "Cash-Pooling",
				yAxis: 4,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "ueberliquiditaet1",
				data: this.data.liquidierungen2,
			},
			{
				name: "Anlage Überliquidität",
				id: "ueberliquiditaet1",
				legendName: "Cash-Pooling",
				yAxis: 1,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				legendIndex: 4,
				zIndex: 2,
				stack: "ein_ausgaben",
				data: this.data.ueberliquiditaeten1,
			},
			{
				name: "Anlage Überliquidität",
				id: "ueberliquiditaet2",
				legendName: "Cash-Pooling",
				yAxis: 4,
				type: "column",
				color: farbeLiquidierung,
				index: 1,
				zIndex: 2,
				stack: "ein_ausgaben",
				linkedTo: "ueberliquiditaet1",
				data: this.data.ueberliquiditaeten2,
			},
		]
	},

	seriesNetto() {
		return [
			{
				name: "Kapitalanlagen",
				id: "kapitalanlagen1",
				legendName: "Kapitalanlagen",
				yAxis: 0,
				type: "area",
				color: kapitalanlagen,
				stack: "netto",
				data: this.data.kapitalanlagen1,
			},
			{
				name: "Kapitalanlagen",
				id: "kapitalanlagen2",
				legendName: "Kapitalanlagen",
				yAxis: 3,
				type: "area",
				color: kapitalanlagen,
				stack: "netto",
				linkedTo: "kapitalanlagen1",
				data: this.data.kapitalanlagen2,
			},
			{
				name: "Sonstige Vermögenswerte",
				id: "sonstigevermoegenswerte1",
				legendName: "Sonstige Vermögenswerte",
				yAxis: 0,
				type: "area",
				color: farbeSonstigeVermoegenswerte,
				stack: "netto",
				data: this.data.sonstigevermoegenswerte1,
			},
			{
				name: "Sonstige Vermögenswerte",
				id: "sonstigervermoegenswerte2",
				legendName: "Sonstige Vermögenswerte",
				yAxis: 3,
				type: "area",
				color: farbeSonstigeVermoegenswerte,
				stack: "netto",
				linkedTo: "sonstigevermoegenswerte1",
				data: this.data.sonstigevermoegenswerte2,
			},
			{
				name: "Immobilien",
				id: "immobilien1",
				legendName: "Immobilien",
				yAxis: 0,
				type: "area",
				color: farbeImmobilien,
				stack: "netto",
				data: this.data.immobilien1,
			},
			{
				name: "Immobilien",
				id: "immobilien2",
				legendName: "Immobilien",
				yAxis: 3,
				type: "area",
				color: farbeImmobilien,
				stack: "netto",
				linkedTo: "immobilien1",
				data: this.data.immobilien2,
			},
			{
				name: "Unternehmen",
				id: "unternehmen1",
				legendName: "Unternehmen",
				yAxis: 0,
				type: "area",
				color: farbeUnternehmen,
				stack: "netto",
				data: this.data.unternehmen1,
			},
			{
				name: "Unternehmen",
				id: "unternehmen2",
				legendName: "Unternehmen",
				yAxis: 3,
				type: "area",
				color: farbeUnternehmen,
				stack: "netto",
				linkedTo: "unternehmen1",
				data: this.data.unternehmen2,
			},
			{
				name: "Liquidität",
				id: "liquiditaet1",
				legendName: "Liquidität",
				yAxis: 2,
				type: "area",
				color: farbeEinnahmen,
				data: this.data.liquiditaet1,
			},
			{
				name: "Liquidität",
				id: "liquiditaet2",
				legendName: "Liquidität",
				yAxis: 5,
				type: "area",
				color: farbeEinnahmen,
				linkedTo: "liquiditaet1",
				data: this.data.liquiditaet2,
			},
		]
	},
	seriesGesamt() {
		return [
			{
				name: "Bruttovermögen",
				id: "bruttovermoegen1",
				legendName: "Bruttovermögen",
				yAxis: 0,
				type: "area",
				color: farbeBruttovermoegen,
				stack: "brutto",
				data: this.data.bruttovermoegen1,
			},
			{
				name: "Bruttovermögen",
				id: "bruttovermoegen2",
				legendName: "Bruttovermögen",
				yAxis: 3,
				type: "area",
				color: farbeBruttovermoegen,
				linkedTo: "bruttovermoegen1",
				stack: "brutto",
				data: this.data.bruttovermoegen2,
			},
			{
				name: "Nettovermögen",
				id: "nettovermoegen1",
				legendName: "Nettovermögen",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				stack: "netto",
				data: this.data.nettovermoegen1,
			},
			{
				name: "Nettovermögen",
				id: "nettovermoegen2",
				legendName: "Nettovermögen",
				yAxis: 3,
				type: "area",
				color: farbeNettovermoegen,
				linkedTo: "nettovermoegen1",
				stack: "netto",
				data: this.data.nettovermoegen2,
			},
			{
				name: "Verbindlichkeiten",
				id: "verbindlichkeiten1",
				legendName: "Verbindlichkeiten",
				yAxis: 0,
				type: "area",
				color: farbeVerbindlichkeiten,
				stack: "verbindlichkeiten",
				data: this.data.verbindlichkeiten1,
			},
			{
				name: "Verbindlichkeiten",
				id: "verbindlichkeiten2",
				legendName: "Verbindlichkeiten",
				yAxis: 3,
				type: "area",
				zIndex: 1,
				color: farbeVerbindlichkeiten,
				linkedTo: "verbindlichkeiten1",
				stack: "verbindlichkeiten",
				data: this.data.verbindlichkeiten2,
			},
		]
	},
}
